module.exports = __webpack_public_path__ + "static/media/descrip5.76f66b59.jpg";